import {
  ComparisonEnvironment,
  ShadowTestResultResponse,
} from "../lusca-search-api/generated-src";

export const DEFAULT_COMPARISON_ENVIRONMENT = ComparisonEnvironment.Gamma;

export const comparisonEnvironmentLabel = (
  environment: ComparisonEnvironment
) => (environment === ComparisonEnvironment.Beta ? "Beta" : "Gamma");

export const comparisonEnvironmentStageName = (
  environment: ComparisonEnvironment
) => (environment === ComparisonEnvironment.Beta ? "beta" : "gamma");

export const resultComparisonEnvironment = (result: ShadowTestResultResponse) =>
  result.comparisonEnvironment ?? DEFAULT_COMPARISON_ENVIRONMENT;

export const relabelComparisonEnvironment = (
  value: string | undefined,
  environment: ComparisonEnvironment
) => {
  if (!value || environment !== ComparisonEnvironment.Beta) {
    return value;
  }

  return value
    .split("+")
    .map((part) => {
      if (part.toLowerCase() !== "gamma") {
        return part;
      }
      if (part === part.toUpperCase()) {
        return "BETA";
      }
      if (part[0] === part[0]?.toUpperCase()) {
        return "Beta";
      }
      return "beta";
    })
    .join("+");
};

export const onlyAvailableComparisonEnvironment = (
  gammaResult: ShadowTestResultResponse | null | undefined,
  betaResult: ShadowTestResultResponse | null | undefined
) => {
  if (betaResult && !gammaResult) {
    return ComparisonEnvironment.Beta;
  }
  if (gammaResult && !betaResult) {
    return ComparisonEnvironment.Gamma;
  }
  return undefined;
};
